import moment from 'moment';

export default [ 'basket', 'suggestionsApiService', 'availabilityApiService', 'startTimeApiService', 'startTimeService', 'quantityApiService', 'propertyService', function (basket, suggestionsApiService, availabilityApiService, startTimeApiService, startTimeService, quantityApiService, propertyService) {
  this.suggestions = null;
  this.availableUpgrades = {};
  this.availableRelated = {};
  this.startTimes = {};

  const getSuggestions = () => {
    if (!this.gettingSuggestions) {
      this.gettingSuggestions = true;

      return suggestionsApiService.find(basket.contents.identity_code)
        .then(response => {
          this.gettingSuggestions = false;
          this.suggestions = response;

          let subRequests = [];

          if (response.upgrades) {
            subRequests.push(getUpgradeAvailability(response.upgrades));
          }

          if (response.events) {
            this.availableRelated = response.events;
          }

          return Promise.all(subRequests);
        });
    }

    return Promise.resolve();
  };

  const hasRelated = () => {
    for (const type in this.availableRelated) {
      if (this.availableRelated[type].length > 0) {
        return true;
      }
    }

    return false;
  };

  const getAvailableUpgrade = (date, type, upgradeId, startTime, upgradeQuantity = 1) => {
    if (this.availableUpgrades[type] &&
            this.availableUpgrades[type][date]) {
      const upgrade = this.availableUpgrades[type][date].find((upgrade) => upgrade.id === upgradeId);
      if (upgrade && upgrade.availability && upgrade.availability.available) {
        if (startTime && noStartTime(date, type, upgrade.id, startTime)) {
          return false;
        }

        if (upgradeQuantity >= 1 && noAvailableQuantity(date, type, upgrade.id, startTime, upgradeQuantity)) {
          return false;
        }

        return upgrade;
      }
    }
  };

    // Private functions
  const getUpgradeAvailability = (responseUpgrades) => {
    this.availableUpgrades = {};
    this.startTimes = {};
    let upgradeRequests = [];

    Object.keys(responseUpgrades)
      .forEach(type => {
        if (type === 'OptionGroupOption') {
          return;
        }

        if (Object.keys(responseUpgrades[type]).length) {
          Object.keys(responseUpgrades[type])
            .forEach((date) => {
              upgradeRequests.push(new Promise(resolve => {
                return availabilityApiService.requestAvailabilityList(date, type.toLowerCase(), Object.values(responseUpgrades[type][date]), 'upsell')
                  .then(response => {
                    assignUpgradeResponse(date, type, response);

                    return startTimePromises(date, type, response)
                      .then(() => {
                        resolve();
                      });
                  });
              }));
            });
        }
      });

    return Promise.all(upgradeRequests)
      .then(() => {
        return assignBasketUpgrades();
      });
  };

  const assignUpgradeResponse = (date, type, response) => {
    if (!this.availableUpgrades[type]) {
      this.availableUpgrades[type] = {};
    }
    this.availableUpgrades[type][date] = response;
  };

  const startTimePromises = (date, type, events) => {
    let startTimeRequests = [];

    events.forEach(event => {
      if (event.availability && event.availability.available) {
        startTimeRequests.push(new Promise(resolve => {
          return startTimeApiService.find(date, type.toLowerCase(), event.id)
            .then((timeResponse) => {
              assignStartTimeResponse(date, type, event.id, timeResponse);

              resolve();
            });
        }));
      }
    });

    return Promise.all(startTimeRequests);
  };

  const assignStartTimeResponse = (date, type, eventId, response) => {
    if (!this.startTimes[type]) {
      this.startTimes[type] = {};
    }

    if (!this.startTimes[type][date]) {
      this.startTimes[type][date] = {};
    }

    if (!this.startTimes[type][date][eventId]) {
      this.startTimes[type][date][eventId] = {};
    }

    if (response) {
      response.forEach(startTime => {
        startTime = startTimeService.standardiseTime(startTime.time);
        this.startTimes[type][date][eventId][startTime] = null;
      });
    }
  };

  const assignBasketUpgrades = () => {
    let upgradePromises = [];

    basket.contents.guest_details.forEach(guest => {
      guest.item_details.forEach(basketItem => {
        upgradePromises.push(new Promise(resolve => {
          return findItemUpgrade(basketItem)
            .then(() => {
              if (basketItem.item_children) {
                basketItem.item_children.forEach(child => findItemUpgrade(child));
              }

              resolve();
            });
        }));
      });
    });

    return Promise.all(upgradePromises);
  };

  const findItemUpgrade = (basketItem) => {
    const date = moment(basketItem.date)
      .format('YYYY-MM-DD');

    return new Promise(resolve => {
      if (!basketItem.upgraded && basketItem.item_summary) {
        if (basketItem.item_summary.type_name === 'OptionGroupOption') {
          setOptionUpgrade(basketItem, date);
          return resolve();
        }

        setEventUpgrade(basketItem, date);

        if (basketItem.canUpgradeTo && propertyService.get('hasIntegration')) {
          return getUpgradeQuantity(basketItem, date)
            .then(() => {
              resolve();
            });
        }
      }

      resolve();
    });
  };

  const setOptionUpgrade = (basketItem, date) => {
    if (basketItem.item.option_id > 0 && canUpgrade(date, 'Treatment', basketItem.item.option_id)) {
      basketItem.canUpgradeTo = this.suggestions.upgrades['Treatment'][date][basketItem.item.option_id];
      return;
    }

    if (canUpgrade(date, basketItem.item_summary.type_name, basketItem.item_summary.id)) {
      basketItem.canUpgradeTo = true;
    }
  };

  const setEventUpgrade = (basketItem, date) => {
    if (canUpgrade(date, basketItem.item_summary.type_name, basketItem.item_summary.id)) {
      basketItem.canUpgradeTo = this.suggestions.upgrades[basketItem.item_summary.type_name][date][basketItem.item_summary.id];
    }
  };

  const canUpgrade = (date, type, eventId) => {
    if (this.suggestions.upgrades &&
            this.suggestions.upgrades[type] &&
            this.suggestions.upgrades[type][date]) {

      if (type === 'OptionGroupOption') {
        return this.suggestions.upgrades[type][date].indexOf(eventId) > -1;
      }

      return !!this.suggestions.upgrades[type][date][eventId];
    }
  };

  const containerHasAvailability = (container, checkDates = true) => {
    return typeHasAvailability(container.Treatment, checkDates) ||
            typeHasAvailability(container.SpaDay, checkDates) ||
            typeHasAvailability(container.OptionGroupOption, checkDates);
  };

  const typeHasAvailability = (type, checkDates) => {
    return !!(type &&
            Object.keys(type).length &&
            findAvailableEvents(type, checkDates));
  };

  const findAvailableEvents = (events, byDate) => {
    if (byDate) {
      Object.keys(events)
        .some(date => {
          return findAvailable(events[date]);
        });
    }

    return findAvailable(events);
  };

  const findAvailable = (events) => {
    return !!events.find(event => event.availability && event.availability.available === true);
  };

  const noStartTime = (date, type, eventId, eventStartTime) => {
    if (this.startTimes[type]
            && this.startTimes[type][date]
            && this.startTimes[type][date][eventId]) {
      return !Object.keys(this.startTimes[type][date][eventId])
        .find(startTime => startTime === startTimeService.standardiseTime(eventStartTime));
    }

    eventStartTime = startTimeService.standardiseTime(eventStartTime);

    return this.startTimes[type]
            && this.startTimes[type][date]
            && this.startTimes[type][date][eventId]
            && this.startTimes[type][date][eventId][eventStartTime] === undefined;
  };

  const noAvailableQuantity = (date, type, eventId, eventStartTime, quantity) => {
    eventStartTime = startTimeService.standardiseTime(eventStartTime);

    if (propertyService.get('hasIntegration')) {
      if (this.startTimes[type]
        && this.startTimes[type][date]
        && this.startTimes[type][date][eventId]
        && this.startTimes[type][date][eventId][eventStartTime]) {
        if (this.startTimes[type][date][eventId][eventStartTime] !== null) {
          return this.startTimes[type][date][eventId][eventStartTime] < quantity;
        } else if (this.startTimes[type][date][eventId][eventStartTime] === null && quantity === 1) {
          return false;
        }
      }

      return true;
    }

    return false;
  };

  const getUpgradeQuantity = (basketItem, date) => {
    return new Promise(resolve => {
      const type = basketItem.item_summary.type_name;
      const eventId = basketItem.canUpgradeTo;
      const time = startTimeService.standardiseTime(basketItem.preferred_time);

      if (!type || !date || !eventId || !time) {
        resolve();
      }

      buildStartTimesStructure(type, date, eventId);

      if (this.startTimes[type][date][eventId][time] !== null) {
        resolve();
      }

      if (basketItem.item_summary.minimum_guests === 1) {
        this.startTimes[type][date][eventId][time] = 1;
        resolve();
      }

      return quantityApiService.find(date, type.toLowerCase(), eventId, time)
        .then((response) => {
          this.startTimes[type][date][eventId][time] = response.quantity;
          resolve();
        });
    });
  };

  const buildStartTimesStructure = (type, date, eventId) => {
    if (!this.startTimes[type]) {
      this.startTimes[type] = {};
    }

    if (!this.startTimes[type][date]) {
      this.startTimes[type][date] = {};
    }

    if (!this.startTimes[type][date][eventId]) {
      this.startTimes[type][date][eventId] = {};
    }
  };

  return {
    getSuggestions,
    hasRelated,
    getAvailableUpgrade,
    getRelated: () => this.availableRelated
  };
} ];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/availability/services/suggestions.service.js